const NoDataFound = () => {
    return (
        <div className='text-center'>No Data Found</div>
    )
}

export default NoDataFound